import React, { useEffect, useState } from 'react';
import { Form, Input, Button, DatePicker, message } from 'antd';
import { createWhatsNews, updateWhatsNews } from '../utils/apiClient';
import dayjs from 'dayjs';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { AppSelectorInput } from './AppSelector';

const WhatsNewsForm = ({ item, onClose }) => {
  const [form] = Form.useForm();
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (item) {
      form.setFieldsValue({
        ...item,
        date: item.date ? dayjs(item.date) : null,
      });
      setDescription(item.description || '');
    } else {
      form.resetFields();
      setDescription('');
    }
  }, [item, form]);

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        description,
        date: values.date ? values.date.toISOString() : undefined,
      };
      if (item) {
        await updateWhatsNews(item._id, payload);
        message.success('Updated successfully');
      } else {
        await createWhatsNews(payload);
        message.success('Created successfully');
      }
      onClose(true);
    } catch {
      message.error('Save failed');
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        category: '',
        type: '',
        title: '',
        tags: '',
        description: '',
        date: null,
      }}
    >
      <AppSelectorInput name="category" label="Show on app" required={true} placeholder="Show on app" />
      <Form.Item name="type" label="Type" rules={[{ required: true, message: 'Type is required' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="title" label="Title">
        <Input />
      </Form.Item>
      <Form.Item name="tags" label="Tags (comma separated)">
        <Input />
      </Form.Item>
      <Form.Item label="Description">
        <ReactQuill theme="snow" value={description} onChange={setDescription} />
      </Form.Item>
      <Form.Item name="date" label="Date" rules={[{ required: true, message: 'Date is required' }]}>
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
          {item ? 'Update' : 'Create'}
        </Button>
        <Button onClick={() => onClose(false)}>Cancel</Button>
      </Form.Item>
    </Form>
  );
};

export default WhatsNewsForm;

